import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export async function createSecret(payload) {
  const { data } = await api.post("/secrets", payload);
  return data;
}

export async function getSecretMeta(id) {
  const { data } = await api.get(`/secrets/${id}/meta`);
  return data;
}

export async function consumeSecret(id, password) {
  const { data } = await api.post(`/secrets/${id}/consume`, { password: password || null });
  return data;
}

export async function burnSecret(id) {
  const { data } = await api.delete(`/secrets/${id}`);
  return data;
}

export async function sendLinkByEmail(id, payload) {
  const { data } = await api.post(`/secrets/${id}/send-link`, payload);
  return data;
}

export async function healthCheck() {
  const { data } = await api.get("/health");
  return data;
}

/**
 * Extracts the backend's structured error_code from an Axios error.
 * Backend responses look like: { detail: { error_code: "secret_not_found" } }
 * Falls back to "generic" if the response doesn't match that shape
 * (e.g. network error, timeout, or an unexpected backend response).
 */
export function getErrorCode(err) {
  const detail = err?.response?.data?.detail;
  if (detail && typeof detail === "object" && typeof detail.error_code === "string") {
    return detail.error_code;
  }
  return "generic";
}

/**
 * Resolves a backend error into a translated, user-facing message.
 * Usage: translateApiError(t, err)
 * Requires the locale files to have an "errors" section with matching keys
 * (see backend/locales/*.json) and an "errors.generic" fallback entry.
 */
export function translateApiError(t, err) {
  const code = getErrorCode(err);
  return t(`errors.${code}`, { defaultValue: t("errors.generic") });
}
